import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, Observable, throwError } from 'rxjs';

import { AUTH_STRINGS } from 'src/app/shared/constants/app-strings.constants';
import { environment } from 'src/environments/environment.development';
import { AuthService } from '../services/auth.service';

export class AuthInterceptorService implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const localEnvironment = window.location.href.indexOf('.com') === -1;
    const serverlessApi = this.isServerlessApi(req.url);

    if (req.headers.has('X-Skip-AuthInterceptor')) {
      const headers = req.headers.delete('X-Skip-AuthInterceptor');
      req = req.clone({ headers });
    } else {
      const idtoken = sessionStorage.getItem(AUTH_STRINGS.idtoken);
      req = req.clone({
        headers: req.headers.append('Authorization', `${idtoken}`),
      });
    }

    if (localEnvironment && serverlessApi) {
      req = this.applyCorsPolicy(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          sessionStorage.removeItem(AUTH_STRINGS.idtoken);
          this.authService.loginLogoutStatus$.next();
        }

        return throwError(() => error);
      })
    );
  }

  private isServerlessApi(url: string): boolean {
    if (!url) {
      return false;
    }
    if (/api./.test(url)) {
      return true;
    }
    return false;
  }

  private applyCorsPolicy(req: HttpRequest<any>): HttpRequest<any> {
    if (/api/.test(req.url)) {
      return req.clone({
        url: req.url.replace(environment.API_URL, ''),
      });
    }
    if (/dev.api.sso/.test(req.url)) {
      return req.clone({
        url: req.url.replace(environment.SSO_API_URL, ''),
      });
    }

    return req;
  }
}
